import { StyledFlex } from '@dreryk/react-components';

import { MedicalDeviceOrderFormRegister, MedicalDeviceOrderFormWatch } from '../medicalDeviceOrder.types';
import { shouldDisplayContinuationField } from '../medicalDeviceOrder.utils';

import { ContinuationField } from './ContinuationField';
import { DeviceTypeField } from './DeviceTypeField';
import { MedicalDeviceSearch } from './MedicalDeviceSearch';

type MedicalDeviceFormConfigurationSectionProps = {
   readonly register: MedicalDeviceOrderFormRegister;
   readonly watch: MedicalDeviceOrderFormWatch;
};

export const MedicalDeviceFormConfigurationSection = (
   props: MedicalDeviceFormConfigurationSectionProps
): JSX.Element => {
   return (
      <StyledFlex gap={'24px'} direction={'column'}>
         <DeviceTypeField register={props.register} />
         <StyledFlex gap={'12px'} direction={'column'}>
            <MedicalDeviceSearch register={props.register} watch={props.watch} />
            {shouldDisplayContinuationField(
               props.register,
               Boolean(props.watch('device')?.fieldsConfiguration.continuation.available)
            ) ? (
               <ContinuationField register={props.register} />
            ) : null}
         </StyledFlex>
      </StyledFlex>
   );
};
